const money = (n) => `$${(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export function ChannelTable({ rows, title = "By marketing channel (first touch)" }) {
  if (!rows?.length) return null;
  return (
    <div className="bg-white rounded-xl border border-zinc-200 p-4" data-testid="channel-table">
      <h3 className="text-sm font-semibold text-zinc-900 mb-3">{title}</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-wide text-zinc-500 border-b">
              <th className="py-2 pr-3">Channel</th><th className="py-2 pr-3">Estimates</th><th className="py-2 pr-3">Booked</th>
              <th className="py-2 pr-3">Paid</th><th className="py-2 pr-3">Revenue</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.channel} className="border-b border-zinc-100" data-testid={`channel-row-${r.channel.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <td className="py-2 pr-3 font-medium">{r.channel}</td>
                <td className="py-2 pr-3">{r.estimates}</td>
                <td className="py-2 pr-3">{r.booked} <span className="text-zinc-500">({r.quote_book_rate}%)</span></td>
                <td className="py-2 pr-3">{r.paid} <span className="text-zinc-500">({r.close_rate_paid}%)</span></td>
                <td className="py-2 pr-3">{money(r.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function ChannelBadge({ lead }) {
  if (!lead?.channel) return null;
  const last = lead.last_touch_channel && lead.last_touch_channel !== lead.channel ? ` → ${lead.last_touch_channel}` : "";
  return (
    <span className="px-1.5 py-0.5 bg-emerald-100 text-emerald-800 rounded text-xs font-medium" data-testid="lead-channel-badge"
      title="First touch → last touch">
      {lead.channel}{last}
    </span>
  );
}
